module.exports = __webpack_public_path__ + "smoking.44aca254.webm";